<script>
    import Footer from '../landing_page/footer.svelte';
    import NavbarMenu from '../navbar/navbar_menu.svelte';
    import Navbar from '../navbar/navbar.svelte';
    const {title} = rpcjs.props;
    title.set('Payment');
    let selector;
    let selectorMbl;
    let card;
    let bitcoin;
    let cardMbl;
    let bitcoinMbl;
    let check = 1;
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>

<section>
    <div class="mobile">
        <NavbarMenu backgroundColor="transparent" stroke="black" />
        <div class="heading-mobile">
            <p>Payment</p>
        </div>
    </div>
    <div>
        <Navbar />
        <div
            class="desktop"
            style="width: 1.786vw;  margin-top: 11.653vw; margin-left: 2.513vw;"
        >
            <img src="images/payment_page/back.svg" alt="" width="100%" />
        </div>
        <div class="display">
            <div>
                <div class="logo_draper">
                    <div class="logo-img">
                        <img
                            src="images/header/draperlogo.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                </div>
                <div class="application_div">
                    <p class="heading" style="">Application Fee</p>
                    <p class="fee-tag">$5.00</p>
                    <p class="pre-heading" style="">
                        This is a non-refundable processing fee that will be
                        applied into your tution fee if you are accepted into
                        the program.
                    </p>
                </div>
                <div
                    class="desktop"
                    style="margin-left: 22.222vw;margin-top: 1.19vw;"
                >
                    <p
                        style="font-size: 0.728vw; color:#919191; font-weight:700;"
                    >
                        Powered by stripe &emsp; &emsp; &emsp;Terms&emsp; &emsp;
                        Privacy
                    </p>
                </div>
            </div>
            <div style="margin-left: 9.193vw;margin-top: 3.5vw;">
                <p class="desktop" style="font-size: 1.984vw; font-weight:600;">
                    Pay through
                </p>
                <div class="desktop">
                    <div>
                        <ul
                            style="list-style: none;display: flex;padding: 1vw 0vw;"
                        >
                            <div class="ani" bind:this={selector} />
                            <li
                                class="selected"
                                on:click={() => {
                                    if (card.style.display === 'block') {
                                        card.style.display = 'none';
                                        bitcoin.style.display = 'block';
                                    } else {
                                        card.style.display = 'block';
                                        bitcoin.style.display = 'none';
                                    }
                                    check = 1;
                                    selector.style.marginLeft = '-0.1vw';
                                    selector.style.transitionDuration = '0.1s';
                                    selector.style.width = '7.85vw';
                                    selector.style.borderTopLeftRadius =
                                        '0.8vw';
                                    selector.style.borderTopRightRadius = '0vw';
                                }}
                            >
                                {#if check === 1}
                                    <p
                                        style="position: absolute;padding-left: 3vw;color: #ffffff; "
                                    >
                                        Card
                                    </p>
                                {:else}
                                    <p class="card-text">Card</p>
                                {/if}
                            </li>
                            <li
                                class="selected"
                                on:click={() => {
                                    if (bitcoin.style.display === 'block') {
                                        bitcoin.style.display = 'none';
                                        card.style.display = 'block';
                                    } else {
                                        bitcoin.style.display = 'block';
                                        card.style.display = 'none';
                                    }
                                    check = 3;
                                    card.style.display = 'none';
                                    selector.style.marginLeft = '7.95vw';
                                    selector.style.transitionDuration = '0.1s';
                                    selector.style.width = '7.85vw';
                                    selector.style.borderTopLeftRadius = '0vw';
                                    selector.style.borderTopRightRadius =
                                        '0.8vw';
                                }}
                                style="border-right: none;"
                            >
                                {#if check === 3}
                                    <p
                                        style="position: absolute;padding-left: 3vw;color: #ffffff; "
                                    >
                                        Bitcoin
                                    </p>
                                {:else}
                                    <p class="card-text">Bitcoin</p>
                                {/if}
                            </li>
                        </ul>
                    </div>
                    <!---Card Form -->
                    <div class="card-form" bind:this={card}>
                        <form>
                            <div>
                                <p class="input-label">E-Mail</p>
                                <input
                                    type="text"
                                    placeholder="example@domain.com"
                                    style="width:25.132vw;"
                                />
                            </div>
                            <div style="margin-top: 0.992vw;">
                                <p class="input-label">Name on Card</p>
                                <input
                                    type="text"
                                    placeholder="eg, “Joe”"
                                    style="width:18.915vw;"
                                />
                            </div>
                            <div style="margin-top: 0.992vw;">
                                <p class="input-label">Card Information</p>
                                <div
                                    style="width:25.132vw;border: 0.132vw solid #ababab;border-radius: 0.661vw;"
                                >
                                    <div style="display: flex;">
                                        <div>
                                            <input
                                                class="card-info"
                                                type="text"
                                                placeholder="1234 1234 1234 1234"
                                                style="width:18.915vw; border:none;"
                                            />
                                        </div>
                                        <div
                                            style="width: 7.275vw;margin-top: 0.6vw;margin-right: 1vw;"
                                        >
                                            <img
                                                src="images/payment_page/visa_card_icon.svg"
                                                alt=""
                                                width="100%"
                                            />
                                        </div>
                                    </div>
                                    <div style="display: flex;">
                                        <div>
                                            <input
                                                type="text"
                                                placeholder="MM/YY"
                                                style="    width: 12.698vw;
                                            border: none;
                                            border-top: 0.132vw solid #ABABAA;
                                            border-top-left-radius: 0;
                                            border-top-right-radius: 0;
                                            border-right: 0.132vw solid #ababab;
                                            border-bottom-right-radius: 0;
                                            margin-left: -0.01vw;"
                                            />
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                placeholder="CVC"
                                                style="width: 12.25vw;
                                            border: none;
                                            border-top: 0.132vw solid #ABABAA;
                                            border-top-left-radius: 0;
                                            border-top-right-radius: 0;
                                            border-bottom-right-radius: -1vw;"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top: 0.992vw;">
                                <p class="input-label">Country or Region</p>

                                <select
                                    style="width: 18.915vw; color: rgba(171, 171, 171, 1);"
                                >
                                    <option>Please Select</option>
                                    <option>Pakistan</option>
                                    <option>SWitzerland</option>
                                    <option>Italy</option>
                                    <option>America</option>
                                </select>
                            </div>
                        </form>
                        <div style="margin-top: 0.992vw;">
                            <button
                                style=" background-color: rgba(60, 116, 192, 1);
                        border-radius: 1.984vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 1.190vw;"
                                >Next</button
                            >
                        </div>
                    </div>
                    <!--Bitcoin Form-->
                    <div class="bitcoin" bind:this={bitcoin}>
                        <form>
                            <div>
                                <p class="input-label">E-Mail</p>
                                <input
                                    type="text"
                                    placeholder="example@domain.com"
                                    style="width:25.132vw;"
                                />
                            </div>
                            <div style="margin-top: 0.992vw;">
                                <p class="input-label">Full Name</p>
                                <input
                                    type="text"
                                    placeholder="eg, “Joe”"
                                    style="width:18.915vw;"
                                />
                            </div>
                            <div style="margin-top: 0.992vw;">
                                <p class="input-label">Enter Amount</p>
                                <div
                                    style="width:25.132vw;border: 0.132vw solid #ababab;border-radius: 0.661vw; display:flex;"
                                >
                                    <div>
                                        <select
                                            style="width: 5.915vw; color: rgba(171, 171, 171, 1);border:none;
                                            background-position-x: 4.4vw;
                                            background-position-y: 1.2vw;"
                                        >
                                            <option>USD</option>
                                            <option>EUR</option>
                                            <option>BTC</option>
                                            <option>sats</option>
                                            <option>MXN</option>
                                            <option>GBP</option>
                                            <option>BRL</option>
                                            <option>AUD</option>
                                            <option>VEF</option>
                                        </select>
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            placeholder=""
                                            style="width:18.915vw;border-left:0.132vw solid #ababab;margin-left: -0.2vw;
                                            border-radius: 0vw;
                                            border-top: none;
                                            border-bottom: none;
                                            border-right: none;"
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div style="margin-top: 1vw;" >
                            <p style="font-size: 0.661vw;">By providing your information, you give explicit consent to OpenNode to store <br>
                                and provide this information to the merchant. View <span style="color:#3A82B9; cursor:pointer;" on:click={() => (location.href = '/privacy_policy')} > Privacy Policy</span></p>
                        </div>
                        <div style="display: flex; margin-top:5vw;">
                            <div style="width: 1.2vw;">
                                <img src="images/payment_page/secure_logo.svg" alt="" width="100%">
                            </div>
                            <div style="    margin-left: 1.23vw;">
                                <p style="font-size:0.794vw;padding-top: 0.3vw;">Secured by  <span style="color:#07204B; font-weight:600;">opennode</span></p>
                            </div>
                        </div>
                        <div style="margin-top: 0.992vw;">
                            <button
                                style=" background-color: rgba(60, 116, 192, 1);
                        border-radius: 1.984vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 1.190vw;"
                                >Next</button
                            >
                        </div>
                    </div>
                </div>
                <div class="mobile">
                    <div>
                        <ul
                            style="list-style: none;display: flex;padding: 1vw 0vw;"
                        >
                            <div class="ani-mbl" bind:this={selectorMbl} />
                            <li
                                class="selected"
                                on:click={() => {
                                    if (cardMbl.style.display === 'block') {
                                        cardMbl.style.display = 'none';
                                        bitcoinMbl.style.display = 'block';
                                    } else {
                                        cardMbl.style.display = 'block';
                                        bitcoinMbl.style.display = 'none';
                                    }
                                    check = 1;
                                    selectorMbl.style.marginLeft = '-0.1vw';
                                    selectorMbl.style.transitionDuration =
                                        '0.5s';
                                    selectorMbl.style.width = '26vw';
                                    selectorMbl.style.borderTopLeftRadius =
                                        '2.5vw';
                                    selectorMbl.style.borderTopRightRadius =
                                        '0vw';
                                }}
                            >
                                {#if check === 1}
                                    <p
                                        style="position: absolute;padding-left: 9vw;color: #ffffff; "
                                    >
                                        Card
                                    </p>
                                {:else}
                                    <p class="card-text">Card</p>
                                {/if}
                            </li>
                            <li
                                class="selected"
                                on:click={() => {
                                    if (bitcoinMbl.style.display === 'block') {
                                        bitcoinMbl.style.display = 'none';
                                        cardMbl.style.display = 'block';
                                    } else {
                                        bitcoinMbl.style.display = 'block';

                                        cardMbl.style.display = 'none';
                                    }
                                    check = 3;
                                    selectorMbl.style.marginLeft = '26.6vw';
                                    selectorMbl.style.transitionDuration =
                                        '0.5s';
                                    selectorMbl.style.width = '26vw';
                                    selectorMbl.style.borderTopLeftRadius =
                                        '0vw';
                                    selectorMbl.style.borderTopRightRadius =
                                        '2.5vw';
                                }}
                                style="border-right: none;"
                            >
                                {#if check === 3}
                                    <p
                                        style="position: absolute;padding-left: 9vw;color: #ffffff; "
                                    >
                                        Bitcoin
                                    </p>
                                {:else}
                                    <p class="card-text">Bitcoin</p>
                                {/if}
                            </li>
                        </ul>
                    </div>
                    <!---Card Form-->
                    <div class="card-form" bind:this={cardMbl}>
                        <form>
                            <div>
                                <p class="input-label">E-Mail</p>
                                <input
                                    type="text"
                                    placeholder="example@domain.com"
                                    style="width:83.889vw;"
                                />
                            </div>
                            <div style="margin-top: 0.992vw;">
                                <p class="input-label">Name on Card</p>
                                <input
                                    type="text"
                                    placeholder="eg, “Joe”"
                                    style="width:63.056vw;"
                                />
                            </div>
                            <div style="margin-top: 0.992vw;">
                                <p class="input-label">Card Information</p>
                                <div
                                    style="width:83.889vw;border: 0.132vw solid #ababab;border-radius: 2.208vw;"
                                >
                                    <div style="display: flex;">
                                        <div>
                                            <input
                                                class="card-info"
                                                type="text"
                                                placeholder="1234 1234 1234 1234"
                                                style="width:49.915vw; border:none;"
                                            />
                                        </div>
                                        <div
                                            style="width: 19.275vw;margin-top: 0.9vw;margin-left: 11vw;"
                                        >
                                            <img
                                                src="images/payment_page/visa_card_icon.svg"
                                                alt=""
                                                width="100%"
                                            />
                                        </div>
                                    </div>
                                    <div style="display: flex;">
                                        <div>
                                            <input
                                                type="text"
                                                placeholder="MM/YY"
                                                style="    width: 41.183vw;
                                            border: none;
                                            border-top: 0.132vw solid #ABABAA;
                                            border-top-left-radius: 0 !important; 
                                            border-top-right-radius: 0 !important;
                                            border-right: 0.132vw solid #ababab;
                                            border-bottom-right-radius: 0 !important;
                                            margin-left: -0.01vw;"
                                            />
                                        </div>
                                        <div>
                                            <input
                                                type="text"
                                                placeholder="CVC"
                                                style="width: 42.2vw;;
                                            border: none;
                                            border-top: 0.132vw solid #ABABAA;
                                            border-top-left-radius: 0 !important;
                                            border-top-right-radius: 0 !important;
                                            border-bottom-right-radius: -1vw;"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top: 0.992vw;">
                                <p class="input-label">Country or Region</p>
                                <select
                                    style="width: 63.056vw; color: rgba(171, 171, 171, 1);"
                                >
                                    <option>Please Select</option
                                    >./blog_content/blog_content.svelte
                                    <option>Pakistan</option>
                                    <option>SWitzerland</option>
                                    <option>Italy</option>
                                    <option>America</option>
                                </select>
                            </div>
                        </form>
                        <div style="margin-top: 5vw; margin-bottom:5vw;">
                            <button
                                style=" background-color: rgba(60, 116, 192, 1);
                        border-radius: 6.623vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 3.975vw;"
                                >Next</button
                            >
                        </div>
                    </div>
                    <!---Bitcoin Form-->
                    <div class="bitcoinMbl" bind:this={bitcoinMbl}>
                        <form>
                            <div>
                                <p class="input-label">Full Name</p>
                                <input
                                    type="text"
                                    placeholder="example@domain.com"
                                    style="width:83.889vw;"
                                />
                            </div>
                            <div style="margin-top: 0.992vw;">
                                <p class="input-label">Full Name</p>
                                <input
                                    type="text"
                                    placeholder="eg, “Joe”"
                                    style="width:63.056vw;"
                                />
                            </div>
                            <div style="margin-top: 0.992vw;">
                                <p class="input-label">Enter Amount</p>
                                <div
                                    style="display: flex;width:83.889vw;border: 0.132vw solid #ababab;border-radius: 2.208vw;"
                                >
                                    <div>
                                        <select
                                            style="    width: 19.915vw;
                                            color: rgb(171, 171, 171);
                                            border: none;
                                            background-position: 15.4vw 3.5vw;"
                                        >
                                            <option>USD</option>
                                            <option>EUR</option>
                                            <option>BTC</option>
                                            <option>sats</option>
                                            <option>MXN</option>
                                            <option>GBP</option>
                                            <option>BRL</option>
                                            <option>AUD</option>
                                            <option>VEF</option>
                                        </select>
                                    </div>
                                    <div>
                                        <input
                                            type="text"
                                            placeholder=""
                                            style="width:61.915vw;border-left:0.132vw solid #ababab;margin-left: -0.2vw;
                                        border-radius: 0vw !important;
                                        border-top: none;
                                        border-bottom: none;
                                        border-right: none;"
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div style="margin-top: 4vw;" >
                            <p style="font-size: 2.211vw;">By providing your information, you give explicit consent to OpenNode to store <br>
                                and provide this information to the merchant. View <span style="color:#3A82B9; cursor:pointer;" on:click={() => (location.href = '/privacy_policy')}> Privacy Policy</span></p>
                        </div>
                        <div style="display: flex; margin-top:5vw;">
                            <div style="width: 4.2vw;">
                                <img src="images/payment_page/secure_logo.svg" alt="" width="100%">
                            </div>
                            <div style="    margin-left: 3vw;">
                                <p style="font-size:2.653vw;padding-top: 1.5vw;">Secured by  <span style="color:#07204B; font-weight:600;">opennode</span></p>
                            </div>
                        </div>
                        <div style="margin-top: 5vw; margin-bottom:5vw;">
                            <button
                                style=" background-color: rgba(60, 116, 192, 1);
                        border-radius: 6.623vw; border: none; font-weight: 500 ; padding: 1vw 4vw; color: white; font-size: 3.975vw;"
                                >Next</button
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mobile">
        <Footer />
    </div>
</section>

<style>
    .ani {
        position: absolute;
        width: 7.85vw;
        margin-top: 0vw;
        height: 2.7vw;
        background-color: #035ba0;
        margin-left: -0.06vw;
        border-top-left-radius: 0.8vw;
    }
    .ani-mbl {
        position: absolute;
        width: 26vw;
        margin-top: 7.5vw;
        height: 6.7vw;
        background-color: #035ba0;
        margin-left: 0.06vw;
        border-top-left-radius: 2.5vw;
    }
    .logo_draper {
        width: 29.09vw;
        height: fit-content;
        position: relative;
        border: 0.198vw solid #7cc1ff;
        margin-left: 16.667vw;
        margin-top: 3.72vw;
        border-left: none;
        border-top-right-radius: 1.5vw;
    }
    .logo_draper::after {
        content: "";
        height: 1.918vw;
        width: 1.918vw;
        background-color: #f7e05f;
        border-radius: 50%;
        position: absolute;
        top: -1vw;
        left: 2.5vw;
    }
    .application_div {
        width: 29.09vw;
        height: fit-content;
        position: relative;
        border: 0.198vw solid #7cc1ff;
        margin-left: 16.667vw;
        border-left: none;
        border-top: none;
        border-bottom-right-radius: 1.5vw;
        padding: 3vw 4vw;
    }
    .heading {
        font-size: 1.323vw;
        font-weight: 600;
    }
    .selected {
        width: 7.937vw;
        border-bottom: 0.15vw solid #7cc1ff;
        border-right: 0.15vw solid #7cc1ff;
    }
    .bitcoin {
        display: none;
    }
    .bitcoinMbl {
        display: none;
    }
    ul li p {
        font-size: 1.058vw;
        font-weight: 600;
        text-align: center;
        display: block;
        padding: 0.5vw 0vw;
    }
    /* .card-text {
        
    } */
    .fee-tag {
        font-size: 1.984vw;
        color: #559d00;
        font-weight: 600;
    }
    .input-label {
        font-size: 1.058vw;
        color: #00204b;
        font-weight: 700;
    }
    .logo-img {
        width: 25.651vw;
        padding: 4vw 4vw;
    }
    .pre-heading {
        font-size: 0.926vw;
        color: #919191;
        width: 23.479vw;
    }
    input {
        font-size: 1.058vw;
        padding: 0.5vw 2vw;
        border: 0.132vw solid #ababab;
        border-radius: 0.661vw;
    }
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url("images/dropdown.svg");
        background-repeat: no-repeat;
        background-position-x: 17.4vw;
        background-position-y: 1vw;
        background-size: 0.6vw;
    }
    select {
        border: 0.132vw solid rgba(171, 171, 171, 1);
        border-radius: 0.661vw;
        padding-left: 1vw;
        height: 2.7vw;
        background-color: transparent;
    }
    .heading-mobile {
        font-size: 8.333vw;
        font-weight: 600;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        padding-top: 34.167vw;
    }
    .display {
        display: flex;
    }
    .mobile {
        display: none;
    }
    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .display {
            display: block !important;
        }
        .logo_draper {
            width: 73.333vw !important;
            border: 0.454vw solid #7cc1ff !important;
            margin-left: 0vw !important;
            margin-top: 12.72vw !important;
            border-left: none !important;
            border-top-right-radius: 4.5vw !important;
        }
        .application_div {
            width: 73.333vw !important;
            border: 0.454vw solid #7cc1ff !important;
            margin-left: 0vw !important;
            border-left: none !important;
            border-top: none !important;
            border-bottom-right-radius: 4.5vw !important;
            padding-top: 6vw !important;
            padding-left: 14.722vw !important;
        }
        .logo_draper::after {
            height: 3.918vw !important;
            width: 3.918vw !important;
            top: -2vw !important;
            left: 4.5vw !important;
        }
        .logo-img {
            width: 59.651vw !important;
            margin-left: 6vw !important;
        }
        .heading {
            font-size: 3.056vw !important;
        }
        .fee-tag {
            font-size: 4.444vw !important;
        }
        .pre-heading {
            width: 53.611vw !important;
            font-size: 2.5vw !important;
        }
        .selected {
            width: 26.494vw !important;
            margin-top: 8vw !important;
        }
        .input-label {
            font-size: 3.533vw !important;
            margin-bottom: 0vw !important;
            margin-top: 5vw !important;
        }
        input {
            font-size: 3.533vw !important;
            padding: 1.5vw 6vw !important;
            border-radius: 2.208vw !important;
        }
        select {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            background-image: url("images/dropdown.svg");
            background-repeat: no-repeat;
            background-position-x: 55.4vw;
            background-position-y: 3.5vw;
            background-size: 3.6vw;
        }
        select {
            border: 0.132vw solid rgba(171, 171, 171, 1);
            border-radius: 2.208vw;
            padding-left: 6vw;
            height: 9.7vw;
            background-color: transparent;
        }
        ul li p {
            font-size: 3.533vw !important;
        }
    }
</style>
